export var InpageWidgetVendors;
(function (InpageWidgetVendors) {
    InpageWidgetVendors["DPA"] = "DPA";
    InpageWidgetVendors["DATAWRAPPER"] = "Datawrapper";
    InpageWidgetVendors["FINANZEN"] = "Finanzen.de";
    InpageWidgetVendors["TENNISNET"] = "Tennisnet";
    InpageWidgetVendors["MOTORSPORT_TOTAL"] = "Motorsport Total";
    InpageWidgetVendors["NORDBAYERN"] = "Nordbayern";
    InpageWidgetVendors["DAA"] = "DAA";
    InpageWidgetVendors["AROUNDHOME"] = "Aroundhome";
    InpageWidgetVendors["COMADS"] = "CommunicationAds";
    InpageWidgetVendors["SMAVA"] = "Smava";
    InpageWidgetVendors["BAUFI24"] = "Baufi24";
    InpageWidgetVendors["CALCULATORTOOLS"] = "CalculatorTools";
    InpageWidgetVendors["CIVEY"] = "Civey";
    InpageWidgetVendors["OFFERISTA"] = "Offerista";
    InpageWidgetVendors["OPINARY"] = "Opinary";
    InpageWidgetVendors["SPEEDTEST"] = "Speedtest";
    InpageWidgetVendors["TRACDELIGHT"] = "Tracdelight";
})(InpageWidgetVendors || (InpageWidgetVendors = {}));
export const vendorEnumToKeyMap = {
    [InpageWidgetVendors.DPA]: 'dpa',
    [InpageWidgetVendors.DATAWRAPPER]: 'datawrapper',
    [InpageWidgetVendors.FINANZEN]: 'finanzen',
    [InpageWidgetVendors.TENNISNET]: 'tennisnet',
    [InpageWidgetVendors.MOTORSPORT_TOTAL]: 'motorsportTotal',
    [InpageWidgetVendors.NORDBAYERN]: 'nordbayern',
    [InpageWidgetVendors.DAA]: 'daa',
    [InpageWidgetVendors.AROUNDHOME]: 'aroundhome',
    [InpageWidgetVendors.COMADS]: 'comads',
    [InpageWidgetVendors.SMAVA]: 'smava',
    [InpageWidgetVendors.BAUFI24]: 'baufi24',
    [InpageWidgetVendors.CALCULATORTOOLS]: 'calculatortools',
    [InpageWidgetVendors.CIVEY]: 'civey',
    [InpageWidgetVendors.OFFERISTA]: 'offerista',
    [InpageWidgetVendors.OPINARY]: 'opinary',
    [InpageWidgetVendors.SPEEDTEST]: 'speedtest',
    [InpageWidgetVendors.TRACDELIGHT]: 'tracdelight',
};
const definition = {
    datawrapper: {
        vendor: InpageWidgetVendors.DATAWRAPPER,
        ruleset: [],
        needsConsent: false,
        adLabel: false,
        allowedBrands: ['BUNTE', 'CHIP', 'FOCUS'],
    },
    dpa: {
        vendor: InpageWidgetVendors.DPA,
        ruleset: [],
        needsConsent: false,
        adLabel: false,
        allowedBrands: ['FOCUS'],
    },
    finanzen: {
        vendor: InpageWidgetVendors.FINANZEN,
        ruleset: [/.*<div\s+id="fde-slot-am[^"]*".*?"siteKey"\s*:\s*"focusde".*$/s],
        needsConsent: true,
        vendorID: '5f5fe70c5e81e7736a7d9565',
        adLabel: true,
        allowedBrands: ['FOCUS', 'BUNTE', 'CHIP'],
    },
    tennisnet: {
        vendor: InpageWidgetVendors.TENNISNET,
        ruleset: [],
        needsConsent: true,
        vendorID: '6862aa0f93e27d17979950da',
        adLabel: false,
        allowedBrands: ['FOCUS'],
    },
    motorsportTotal: {
        vendor: InpageWidgetVendors.MOTORSPORT_TOTAL,
        ruleset: [],
        needsConsent: false,
        adLabel: false,
        allowedBrands: ['FOCUS'],
    },
    nordbayern: {
        vendor: InpageWidgetVendors.NORDBAYERN,
        ruleset: [],
        needsConsent: false,
        adLabel: false,
        allowedBrands: ['FOCUS', 'BUNTE'],
    },
    daa: {
        vendor: InpageWidgetVendors.DAA,
        ruleset: [],
        needsConsent: false,
        adLabel: true,
        allowedBrands: ['FOCUS', 'BUNTE', 'CHIP'],
    },
    aroundhome: {
        vendor: InpageWidgetVendors.AROUNDHOME,
        ruleset: [],
        needsConsent: false,
        adLabel: true,
        allowedBrands: ['FOCUS', 'BUNTE', 'CHIP'],
    },
    comads: {
        vendor: InpageWidgetVendors.COMADS,
        ruleset: [],
        needsConsent: false,
        adLabel: true,
        allowedBrands: ['FOCUS', 'BUNTE', 'CHIP'],
    },
    smava: {
        vendor: InpageWidgetVendors.SMAVA,
        ruleset: [],
        needsConsent: false,
        adLabel: true,
        allowedBrands: ['FOCUS', 'BUNTE', 'CHIP'],
    },
    baufi24: {
        vendor: InpageWidgetVendors.BAUFI24,
        ruleset: [],
        needsConsent: false,
        adLabel: true,
        allowedBrands: ['FOCUS', 'BUNTE', 'CHIP'],
    },
    calculatortools: {
        vendor: InpageWidgetVendors.CALCULATORTOOLS,
        ruleset: [],
        needsConsent: false,
        adLabel: false,
        allowedBrands: ['FOCUS'],
    },
    civey: {
        vendor: InpageWidgetVendors.CIVEY,
        ruleset: [],
        needsConsent: false,
        adLabel: false,
        allowedBrands: ['BUNTE', 'CHIP'],
    },
    offerista: {
        vendor: InpageWidgetVendors.OFFERISTA,
        ruleset: [],
        needsConsent: false,
        adLabel: true,
        allowedBrands: ['CHIP'],
    },
    opinary: {
        vendor: InpageWidgetVendors.OPINARY,
        ruleset: [],
        needsConsent: false,
        adLabel: false,
        allowedBrands: ['CHIP'],
    },
    speedtest: {
        vendor: InpageWidgetVendors.SPEEDTEST,
        ruleset: [],
        needsConsent: false,
        adLabel: false,
        allowedBrands: ['CHIP'],
    },
    tracdelight: {
        vendor: InpageWidgetVendors.TRACDELIGHT,
        ruleset: [],
        needsConsent: false,
        adLabel: true,
        allowedBrands: ['FOCUS', 'BUNTE', 'CHIP'],
    },
};
export const inpageWidgetVendorConfigByKey = (vendor) => definition[vendor];
export const inpageWidgetVendorConfig = (vendorInput) => Object.values(definition).find((config) => config.vendor === vendorInput);
export const inpageWidgetVendorConfigFromType = (vendorType) => {
    const key = vendorEnumToKeyMap[vendorType];
    if (!key) {
        throw new Error(`Unknown vendor type: ${vendorType}`);
    }
    return inpageWidgetVendorConfigByKey(key);
};
//# sourceMappingURL=inpage-widget.config.js.map